import type { PreApproval } from '../types/portal'

export const preApprovals: PreApproval[] = [
  {
    id: 'OPP-88295',
    borrower: 'Beatrice Lund',
    amount: '$744,900',
    program: 'Jumbo',
    dti: '38%',
    credit: 761,
    status: 'expiring',
    expiresLabel: 'Expires in 6 days',
    lastTouchLabel: 'Last touch 8 days ago',
    weeklyTouchDone: false,
    realtor: 'Curtis Nakamura · Keller Williams',
  },
  {
    id: 'OPP-88342',
    borrower: 'Kelsey Vaughn',
    amount: '$512,000',
    program: 'Conventional',
    dti: '41%',
    credit: 728,
    status: 'ready-to-review',
    expiresLabel: 'Expires in 82 days',
    lastTouchLabel: 'Submitted 3 hours ago',
    weeklyTouchDone: true,
    realtor: 'Renee Ortiz · RE/MAX Alliance',
  },
  {
    id: 'OPP-88317',
    borrower: 'Owen Machado',
    amount: '$367,400',
    program: 'FHA',
    dti: '46%',
    credit: 684,
    status: 'docs-outstanding',
    expiresLabel: 'Expires in 74 days',
    lastTouchLabel: 'Last touch 3 days ago',
    weeklyTouchDone: false,
    realtor: 'Sofia Delgado · Coldwell Banker',
  },
  {
    id: 'OPP-88260',
    borrower: 'Renata Villalobos',
    amount: '$429,900',
    program: 'Conventional',
    dti: '35%',
    credit: 742,
    status: 'approved',
    expiresLabel: 'Expires in 51 days',
    lastTouchLabel: 'Call logged 2 days ago',
    weeklyTouchDone: true,
    realtor: 'Dana Whitfield · Compass',
  },
  {
    id: 'OPP-88244',
    borrower: 'Marcus Odom',
    amount: '$298,000',
    program: 'VA',
    dti: '39%',
    credit: 705,
    status: 'approved',
    expiresLabel: 'Expires in 44 days',
    lastTouchLabel: 'Last touch 11 days ago',
    weeklyTouchDone: false,
    realtor: 'Wes Cardoza · Redfin',
  },
]
